import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFormOctagonRotate: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconFormOctagonRotate"><Path d="M19.1006 4.3584L19.4824 4.51758L19.6416 4.89941L22.582 12L19.6416 19.1006L19.4824 19.4824L19.1006 19.6416L12 22.582L4.89941 19.6416L4.51758 19.4824L4.3584 19.1006L1.41797 12L4.3584 4.89941L4.51758 4.51758L4.89941 4.3584L12 1.41797L19.1006 4.3584Z" fill="currentColor"/></CentralIconBase>;
});

export default IconFormOctagonRotate;
